(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/draw-card.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/draw-card.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const clx = svs.components.lbUtils.clx;
const DRAW_CARD_LAYOUTS = svs.components.tipsen.drawCard.constants.DRAW_CARD_LAYOUTS;
const _svs$components$tipse = svs.components.tipsen.drawCard.context,
  DrawCardContext = _svs$components$tipse.DrawCardContext,
  withinDrawCardContext = _svs$components$tipse.withinDrawCardContext;
const _svs$components$tipse2 = svs.components.tipsen.drawCardComponents,
  DrawCardExtraAmount = _svs$components$tipse2.DrawCardExtraAmount,
  DrawCardLeague = _svs$components$tipse2.DrawCardLeague,
  DrawCardNetSale = _svs$components$tipse2.DrawCardNetSale,
  DrawCardBetEvents = _svs$components$tipse2.DrawCardBetEvents,
  DrawCardToggleBtn = _svs$components$tipse2.DrawCardToggleBtn,
  DrawCardRegCloseTime = _svs$components$tipse2.DrawCardRegCloseTime,
  DrawCardStatus = _svs$components$tipse2.DrawCardStatus,
  DrawCardTitle = _svs$components$tipse2.DrawCardTitle,
  DrawCardChangeDraw = _svs$components$tipse2.DrawCardChangeDraw,
  DrawCardCompetitionDrawNumber = _svs$components$tipse2.DrawCardCompetitionDrawNumber;
const DrawCard = _ref => {
  let children = _ref.children,
    className = _ref.className,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? DRAW_CARD_LAYOUTS.VERTICAL : _ref$layout,
    waiAriaRole = _ref.waiAriaRole,
    branding = _ref.branding;
  const context = useMemo(() => ({
    layout
  }), [layout]);
  const blockName = 'pg_draw_card';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--").concat(branding)]: branding,
    ["".concat(blockName, "--horizontal")]: layout === DRAW_CARD_LAYOUTS.HORIZONTAL
  }, className);
  return React.createElement("div", {
    className: classNames,
    role: waiAriaRole
  }, React.createElement(DrawCardContext.Provider, {
    value: context
  }, children));
};
DrawCard.ExtraAmount = withinDrawCardContext(DrawCardExtraAmount);
DrawCard.League = withinDrawCardContext(DrawCardLeague);
DrawCard.NetSale = withinDrawCardContext(DrawCardNetSale);
DrawCard.BetEvents = withinDrawCardContext(DrawCardBetEvents);
DrawCard.DrawToggleBtn = withinDrawCardContext(DrawCardToggleBtn);
DrawCard.RegCloseTime = withinDrawCardContext(DrawCardRegCloseTime);
DrawCard.Status = withinDrawCardContext(DrawCardStatus);
DrawCard.Title = withinDrawCardContext(DrawCardTitle);
DrawCard.ChangeDraw = withinDrawCardContext(DrawCardChangeDraw);
DrawCard.CompetitionDrawNumber = withinDrawCardContext(DrawCardCompetitionDrawNumber);
setGlobal('svs.components.tipsen.drawCard.DrawCard', DrawCard);

 })(window);